import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderRadius,
  borderWidth,
  borderStyle,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Figma 3812:42285 — title row with a bottom divider (pb 8, px 12). */
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${spacing[3]} ${spacing[3]} ${spacing[3]} ${spacing[3]};
  box-sizing: border-box;
`;

/** Wraps the title row and `belowSlot`; the divider sits under both. */
export const Outer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.stroke[200]};
  box-sizing: border-box;
`;

export const BelowGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
  padding: 0 ${spacing[3]} ${spacing[3]};
  box-sizing: border-box;
`;

/** Leading tile: a rounded square that holds an icon. */
export const LeadingTile = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: ${borderRadius.md};
  background: ${rawColors.primary[100]};
  color: ${rawColors.primary[500]};
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const LogoImg = styled.img`
  display: block;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export const Title = styled.h2`
  margin: 0;
  ${typographyMixin("subtitle", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export const TitleText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Subtitle = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Holds the endSlot; pushes it to the right, before the collapse control. */
export const EndGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
  margin-right: ${spacing[2]};
`;

export const CollapseButton = styled.button<{ $isRound?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $isRound }) => ($isRound ? "32px" : "24px")};
  height: ${({ $isRound }) => ($isRound ? "32px" : "24px")};
  ${({ $isRound }) => ($isRound ? "border-radius: 50%;" : "")}
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${rawColors.text.lowEmphasis};

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
    border-radius: ${borderRadius.sm};
  }
`;
